var _path, _path2, _g, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502.46,
    height: 453.7,
    viewBox: "0 0 502.46 453.7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m255.69 7.4902c-5.1755 0.17641-10.791 3.8018-16.445 13.016-19.513 34.422-179.68 317.2-227.28 398.12-7.5989 15.934 2.1681 26.897 17.422 26.994 80.795-0.29695 362.33 1.3858 441.45 0.07227 14.984 0 24.127-9.8323 24.127-23.984 0.0432-32.699-202.65-367.86-222.34-402.35-4.3462-6.6269-10.274-12.1-16.928-11.873z",
    fill: "#fbec61",
    stroke: "#000",
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m166.85 193.87v107.21h178.69v-107.21zm15.463 13.801h146.83v80.078h-146.83z",
    opacity: 0.999,
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0042 0 0 .78086 -169.06 12.814)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.49,
    y: 379.81,
    width: 218.58,
    height: 68.981,
    opacity: 0.999,
    strokeWidth: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m397.39 316.74 0.10352 4.9805h2.2871v7.8809h-2.123l0.08398 3.9883c4.296-0.03934 9.2682-0.44796 15.154-2.5938-2.3708-8.4006-8.5414-14.041-15.506-14.256zm-1.0156 0.01172c-6.9482 0.31831-13.067 6.0306-15.367 14.463 4.8512 1.4957 9.4901 2.3447 15.352 2.3809 0.0051 3e-5 0.01053-3e-5 0.01563 0v-3.9941h-2.1289v-7.8809h2.1289v-4.9688zm16.746 14.924c-5.5059 2.2335-11.459 3.2461-16.889 3.1914-5.211-0.0525-10.22-1.0239-15.324-2.9043-0.62032 2.2786-0.84151 3.9413-0.8418 6.3535-3.4e-4 11.927 7.5733 21.596 16.916 21.596 9.3427-1e-5 16.916-9.6689 16.916-21.596-5.6e-4 -2.4916-0.11623-4.2963-0.77734-6.6406z",
    opacity: 0.999,
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m396.63 313.13-0.38486-12.513c-0.39785-15.975-13.946-5.71-24.354-9.4068-7.5374-2.0767-7.969-21.12-24.834-18.716",
    fill: "none",
    stroke: "#000",
    strokeWidth: "1px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.7055ec121d3a8008a8f2ab9a905dc9a0.svg";
export { ForwardRef as ReactComponent };